// extracted by mini-css-extract-plugin
export default {"masking":"devicePng_masking__GglrM"};